import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import React from 'react';
import styles from './style/index.module.less';
import Forgot from './forgot';
const FormItem = _Form.Item;

const Index = () => {
  const searchParams = new URLSearchParams(location.search);
  const key = searchParams.get('key');
  console.log(key);

  const [form] = _Form.useForm();

  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['auth-root']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['main-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['form-container']
  }, /*#__PURE__*/React.createElement(Forgot, null)))));
};

export default Index;